import { chowlyApi } from 'config'
import { generatePath } from 'react-router-dom'

import client from '../chowly'
import {
  PartnerWithSyncLifecycleResponse,
  SyncLifecycleStatusResponse,
} from '../models'

export const getPartnerWithSyncLifecycleStatuses = async (
  partnerId: string, 
  syncLifecycleStatus?: 'pending' | 'importing' | 'ineligible' | 'publishing' | 'completed' | 'active'
) => {
  const url = generatePath(chowlyApi.partner, { id: partnerId })
  const params = syncLifecycleStatus ? { sync_lifecycle_status: syncLifecycleStatus, include: 'sync_lifecycle_statuses' } : { include: 'sync_lifecycle_statuses' }
  const { data } = await client.get<PartnerWithSyncLifecycleResponse>(url, { params })
  return data
}

export const getSyncLifecycleStatus = async (id: string) => {
  const url = generatePath(chowlyApi.syncLifecycleStatus, { id })
  const { data } = await client.get<SyncLifecycleStatusResponse>(url)
  return data
}